<template>
  <div
    class="showComd"
    v-bind:style="{
      backgroundImage:
        'url(static/img/bg-' + (continent ? continent : 0) + '.png)',
    }"
  >
    <!--商品名称-->
    <div class="comdName" v-text="name"></div>

    <!--价格-->
    <div class="price">
      <span>￥</span>
      <em v-text="price / 100"></em>
    </div>

    <!-- 办理时长 -->
    <div class="time">
      <span class="span1" v-text="summary && summary.handlePeriod.title"></span>
      <span
        class="span2"
        v-text="summary && summary.handlePeriod.content"
      ></span>
    </div>

    <div class="divider"></div>

    <!--其他信息-->
    <div class="comdDes">
      <!--有效期限-->
      <div class="despire line">
        <p>
          <!-- 如果是"3天"这类的-->
          <span v-if="!summary.validityPeriod.content.isAllString">
            <span
              class="bigChara"
              v-text="summary.validityPeriod.content.num"
            ></span>
            <span v-text="summary.validityPeriod.content.str"></span>
          </span>
          <span
            v-else
            class="bigChara"
            v-text="summary.validityPeriod.content.str"
          ></span>
        </p>
        <p class="trans50" v-text="summary.validityPeriod.title"></p>
      </div>

      <!--最长停留-->
      <div class="stay line">
        <p>
          <span v-if="!summary.maxStayTime.content.isAllString">
            <span
              class="bigChara"
              v-text="summary.maxStayTime.content.num"
            ></span>
            <span v-text="summary.maxStayTime.content.str"></span>
          </span>
          <span
            v-else
            class="bigChara"
            v-text="summary.maxStayTime.content.str"
          ></span>
        </p>
        <p class="trans50" v-text="summary.maxStayTime.title"></p>
      </div>

      <!--入境次数-->
      <div class="count">
        <p>
          <span v-if="!summary.numberOfEntry.content.isAllString">
            <span
              class="bigChara"
              v-text="summary.numberOfEntry.content.num"
            ></span>
            <span v-text="summary.numberOfEntry.content.str"></span>
          </span>
          <span
            v-else
            class="bigChara"
            v-text="summary.numberOfEntry.content.str"
          ></span>
        </p>
        <p class="trans50" v-text="summary.numberOfEntry.title"></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'productBasicInfo',
  props: {
    name: {
      type: String,
    },
    summary: {
      type: Object,
    },
    price: {
      type: Number,
      default() {
        return 100;
      },
    },
    continent: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
};
</script>
<style scoped>
.showComd {
  background-size: 100%;
  width: 100%;
  color: #fff;
  font-size: 0.2rem;
  padding-top: 0.25rem;
}
.comdName {
  width: 3.2rem;
  margin: auto;
  text-align: center;
  font-size: 0.2rem;
  line-height: 0.2rem;
}
.comdName > p {
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 0.3rem;
  height: 0.6rem;
}
.price {
  margin: 0 auto;
  margin-top: 0.35rem;
  width: 100%;
  height: 0.3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.price span {
  font-size: 0.18rem;
  margin-right: 0.05rem;
  margin-top: 0.05rem;
}
.price em {
  font-size: 0.3rem;
  color: #fff;
}
.price div {
  display: inline-block;
  font-size: 0.12rem;
  width: 0.44rem;
  height: 0.22rem;
  background-color: rgba(0, 0, 0, 0.05);
  line-height: 0.22rem;
  border-radius: 0.11rem;
  margin-left: 0.1rem;
  color: rgba(255, 255, 255, 0.8);
}
.time {
  display: flex;
  justify-content: center;
  margin-top: 0.35rem;
  font-size: 0.14rem;
}
.time .span1 {
  color: rgba(255, 255, 255, 0.5);
  margin-right: 0.1rem;
}
.time .span2 {
  color: #fff;
}
.time .span3 {
  margin-left: 0.05rem;
}
.time .span3 img {
  width: 0.05rem;
  height: 0.09rem;
}
.divider {
  margin: auto;
  width: 3.55rem;
  height: 0.01rem;
  background-color: rgba(255, 255, 255, 0.2);
  margin-top: 0.25rem;
}
.comdDes {
  text-align: center;
  height: 0.7rem;
  width: 3.55rem;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.12rem;
  padding-bottom: 0.15rem;
}
.comdDes div {
  position: relative;
  flex-grow: 1;
}
.comdDes .line:after {
  content: '';
  position: absolute;
  top: 0.1rem;
  right: 0;
  width: 1px;
  height: 0.2rem;
  background-color: rgba(255, 255, 255, 0.2);
}
.comdDes .bigChara {
  font-size: 0.22rem;
}
.comdDes .trans50 {
  color: rgba(255, 255, 255, 0.5);
  margin-top: 0.05rem;
}
.comdDes span {
  font-size: 0.12rem;
}
</style>
